import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { RoutesListView } from '../../features/routing/routes-list-view';

export const Route = createFileRoute('/factory-routes/')({
  component: RoutesPage,
});

function RoutesPage() {
  const enabled = useFeatureFlag('routing');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Routing in Quality is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <RoutesListView partnerId={partnerId} />;
}
